import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_IMAGE = "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/933ba291-d562-4801-b20a-fae6de561b45/tegltag-integrerede-solceller-parcelhus.jpg";
const DEFAULT_DESCRIPTION = "Fyns Tømreren er din tømrer på Fyn. Specialister i tag, facade, gulve, køkkenmontering, træterrasser og autoriseret asbestsanering for private og erhverv.";
const SITE_NAME = "Fyns - Tømreren ApS";

function updateTag(selector, attribute, value, createTag) {
  let el = document.querySelector(selector);
  if (!el && createTag) {
    el = createTag();
    document.head.appendChild(el);
  }
  if (el && value !== undefined) {
    el.setAttribute(attribute, value);
  }
}

export default function SEO({ 
  title, 
  description = DEFAULT_DESCRIPTION, 
  isHome = false,
  image = DEFAULT_IMAGE,
  noIndex = false
}) {
  const location = useLocation();

  useEffect(() => {
    // Page Title
    const fullTitle = isHome 
      ? "Tømrer på Fyn | Fyns Tømreren ApS – Tag, facade, køkken & asbestsanering"
      : `${title} | Fyns Tømreren ApS – Tømrer på Fyn`;
    document.title = fullTitle;

    // Meta Description
    updateTag('meta[name="description"]', 'content', description, () => {
      const meta = document.createElement('meta');
      meta.name = 'description';
      return meta;
    });

    // Robots
    updateTag('meta[name="robots"]', 'content', noIndex ? 'noindex, nofollow' : 'index, follow', () => {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      return meta;
    });

    // Canonical link
    const canonicalUrl = typeof window !== 'undefined' ? `${window.location.origin}${location.pathname}` : '';
    if (canonicalUrl) {
      updateTag('link[rel="canonical"]', 'href', canonicalUrl, () => {
        const link = document.createElement('link');
        link.rel = 'canonical';
        return link;
      });
    }

    // Open Graph Tags
    const ogTags = [
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:type', content: isHome ? 'website' : 'article' },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:url', content: canonicalUrl },
      { property: 'og:image', content: image },
      { property: 'og:locale', content: 'da_DK' }
    ];

    ogTags.forEach(({ property, content }) => {
      updateTag(`meta[property="${property}"]`, 'content', content, () => {
        const meta = document.createElement('meta');
        meta.setAttribute('property', property);
        return meta;
      });
    });

    // Twitter Card Tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image }
    ];

    twitterTags.forEach(({ name, content }) => {
      updateTag(`meta[name="${name}"]`, 'content', content, () => {
        const meta = document.createElement('meta');
        meta.name = name;
        return meta;
      });
    });

  }, [title, description, isHome, image, location.pathname, noIndex]);

  return null;
}
